export default "__VITE_ASSET__DgE1sX$u__"